import { Link, Outlet } from 'react-router-dom';
import { Header } from '@/components/common/Header';
import { UserAccountMenu } from '@/components/common/UserAccountMenu';

/**
 * UsageLayout — layout for the Usage History page
 * Custom header: back-to-dashboard button + help icon (no "New page" button)
 */
const UsageLayout = () => {
  const leftContent = (
    <span className="text-[14px] font-semibold text-[#0F172A]">Usage History</span>
  );

  const rightContent = (
    <div className="flex items-center gap-[10px]">
      <Link
        to="/dashboard"
        className="flex items-center gap-[6px] rounded-[6px] border border-[#E2E8F0] bg-transparent px-[12px] py-[9px] text-[13px] font-medium text-[#475569] no-underline transition-all duration-[120ms] hover:border-[#CBD5E1] hover:bg-[#F1F5F9] hover:text-[#0F172A]"
      >
        <i className="fa-solid fa-arrow-left" /> Dashboard
      </Link>
      <div className="bg-border h-[18px] w-px" />
      <Link
        to="/help"
        className="text-foreground/60 hover:text-foreground flex h-[38px] w-[38px] items-center justify-center rounded-[9px] border border-black/[0.07] bg-white text-[14px] no-underline transition-all duration-200 hover:border-black/[0.18]"
        title="Help"
      >
        <i className="fa fa-circle-question" />
      </Link>
      <UserAccountMenu />
    </div>
  );

  return (
    <div className="dark:bg-background text-foreground flex h-full flex-col bg-[#F1F5F9] transition-colors duration-300">
      <Header leftContent={leftContent} rightContent={rightContent} />
      <main className="animate-in fade-in slide-in-from-bottom-2 mx-auto w-full px-4 pt-6 pb-16 duration-500 sm:px-6 sm:pt-8 sm:pb-20">
        <Outlet />
      </main>
    </div>
  );
};

export default UsageLayout;
